import { ArrowLeft, ArrowRight, Sparkles, Compass } from "lucide-react";
import { Link } from "react-router-dom";
import { useI18n, useL } from "../i18n";

export default function HeroSection() {
  const { t, lang } = useI18n();
  const L = useL();
  const Arrow = lang === "ar" ? ArrowLeft : ArrowRight;

  return (
    <section className="relative overflow-hidden bg-[#FAF7F2]" data-testid="hero-section">
      <div className="grain-overlay absolute inset-0 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 pt-10 lg:pt-16 pb-10 lg:pb-20 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
        {/* Copy */}
        <div className="lg:col-span-6 relative z-10 animate-fade-up">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#E6DED3] bg-white/60 backdrop-blur px-3 py-1.5 text-xs text-[#57534E]">
            <span className="h-1.5 w-1.5 rounded-full bg-[#C85A32]" />
            {t("tagline")}
          </div>
          <h1 className="mt-4 font-display text-3xl sm:text-4xl lg:text-6xl leading-[1.05] tracking-tight text-[#1C1917]">
            {t("hero_title")}
          </h1>
          <p className="mt-4 text-base sm:text-lg text-[#57534E] max-w-xl leading-relaxed">
            {t("hero_sub")}
          </p>

          <div className="mt-6 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <Link
              to="/prices"
              data-testid="hero-explore-btn"
              className="group inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-[#1C1917] text-[#FAF7F2] hover:bg-[#C85A32] transition-colors font-medium"
            >
              <Compass className="h-4 w-4" />
              {t("hero_cta_explore")}
              <Arrow className="h-4 w-4 transition-transform group-hover:translate-x-1 rtl:group-hover:-translate-x-1" />
            </Link>
            <Link
              to="/assistant"
              data-testid="hero-ai-btn"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full border-2 border-[#1C1917] hover:bg-[#1C1917] hover:text-[#FAF7F2] transition-colors font-medium"
            >
              <Sparkles className="h-4 w-4" />
              {t("hero_cta_ai")}
            </Link>
          </div>

          <div className="mt-8 grid grid-cols-3 gap-4 max-w-md">
            <Stat n="12+" label={L({ ar: "وجهة", en: "Destinations", fr: "Destinations" })} />
            <Stat n="11" label={L({ ar: "دولة", en: "Countries", fr: "Pays" })} />
            <Stat n="AI" label={L({ ar: "مساعد ذكي", en: "Assistant", fr: "Assistant" })} />
          </div>
        </div>

        {/* Visual bento */}
        <div className="lg:col-span-6 relative">
          <div className="grid grid-cols-6 grid-rows-6 gap-3 h-[440px] sm:h-[520px]">
            <div className="col-span-4 row-span-4 relative rounded-3xl overflow-hidden bg-[#1C1917]">
              <img
                src="https://images.unsplash.com/photo-1580834341580-8c17a3a630ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                alt="Petra"
                className="w-full h-full object-cover opacity-90"
              />
              <div className="absolute bottom-4 start-4 text-[#FAF7F2]">
                <div className="text-[10px] uppercase tracking-widest opacity-80">Jordan</div>
                <div className="font-display text-2xl">{L({ ar: "البتراء", en: "Petra", fr: "Pétra" })}</div>
              </div>
            </div>
            <div className="col-span-2 row-span-3 rounded-3xl overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1661159245219-f1768c7e98c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
                alt="Cappadocia"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="col-span-2 row-span-3 rounded-3xl overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1548018560-4cb48a8837c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
                alt="Marrakech"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="col-span-4 row-span-2 rounded-3xl overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
                alt="Dubai"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ n, label }) {
  return (
    <div>
      <div className="font-display text-3xl text-[#1C1917]">{n}</div>
      <div className="text-xs text-[#78716C] uppercase tracking-widest mt-1">{label}</div>
    </div>
  );
}
